export { default as NDynamicInput, dynamicInputProps } from './src/DynamicInput';
